import { useStaticQuery, graphql } from "gatsby";

const AnnouncementBarQuery = () => {
  const announcementBarData = useStaticQuery(graphql`
    query AnnouncementBarDataQuery {
      allSanityAnnouncementBar {
        nodes {
          ...sanityAnnouncementBar
        }
      }
    }
  `);

  const {
    allSanityAnnouncementBar: { nodes },
  } = announcementBarData;

  const selectedAnnouncementBar = nodes.find(
    node => node.region?.iban === process.env.GATSBY_IBAN
  );

  return selectedAnnouncementBar;
};

export default AnnouncementBarQuery;
